module.exports = __webpack_public_path__ + "static/women-health-adde44f30134fe7d06c42625eb777800.png";